import React from "react";
import { useRecoilState } from "recoil";
import statusMessageState from "../../state/statusMessages";
import ToastItem from "./ToastItem";

const StatusMessage = () => {
  const [messages, setMessages] = useRecoilState(statusMessageState);

  const removeMessage = (id) => {
    setMessages((prev) => prev.filter((msg) => msg.id !== id));
  };

  if (messages.length === 0) return null;

  return (
    <div className="fixed top-6 right-6 z-50 flex flex-col gap-3 items-end">
      {messages.map((msg) => (
        <ToastItem
          key={msg.id}
          {...msg}
          onDismiss={() => removeMessage(msg.id)}
        />
      ))}
    </div>
  );
};

export default StatusMessage;
